import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementImpression from './element-impression';

var CCElementImpression = function CCElementImpression(props) {
  var elementImpressionProps = _objectSpread({
    eventName: 'CC_ELEMENT_IMPRESSION_EVENT'
  }, props);

  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return React.createElement(ElementImpression, _extends({
    verticalImpressionData: ccData
  }, elementImpressionProps));
};

CCElementImpression.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  productId: PropTypes.number.isRequired,
  productImpressionId: PropTypes.string,
  productImpressionKey: PropTypes.string
};
export default CCElementImpression;
var CCElementImpressionConnect = connect(function (state, ownProps) {
  return {
    productImpressionId: get(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementImpression);
export { CCElementImpressionConnect };